import {FC, useLayoutEffect} from "react";
import {gsap} from "gsap";
import TweenTarget = gsap.TweenTarget;
import "./CoinsTop.scss"
import {coin1, coin2, coin3, coin4, coin6, coin7, coin8, coin9, coin10, coin15, coin16, coin17, coin18} from "../coinsImages";

const CoinsTop: FC = () => {
	const coins = [coin3, coin7, coin2, coin1, coin4, coin6, coin8, coin9, coin10, coin15, coin16, coin17, coin18];

	useLayoutEffect(() => {
		let coinsEl: TweenTarget[] = gsap.utils.toArray(".coins-top .coin")
		coinsEl.forEach((coin, index) => {
			gsap.fromTo(coin,{ opacity: 0 },
				{
					clearProps: "all",
					opacity: 1,
					duration: 2,
					delay: index / 5,
					onComplete: () => {gsap.killTweensOf(coin);}
				}
			)
		})
	}, []);

	return(
		<div className="coins-top">
			<div className="coins-top__wrapper">
				{
					coins.map((coin, index) => (
						<div className={`coin coin-${index + 1}`} key={`coin-${index + 1}`}>
							<img src={coin} alt={`coin-${index + 1}`}/>
						</div>
					))
				}
			</div>
		</div>
	)
}
export default CoinsTop